import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'ngx-modal-visualizar-onboard',
  templateUrl: './modal-visualizar-onboard.component.html',
  styleUrls: ['./modal-visualizar-onboard.component.scss']
})
export class ModalVisualizarOnboardComponent implements OnInit {

  @Input() text: string;

  @ViewChild("card", null)

  private card: ElementRef;


  constructor(
    protected ref: NbDialogRef<ModalVisualizarOnboardComponent>
    ) {



    }

  ngOnInit() {
    this.card.nativeElement.ownerDocument.activeElement.blur();

  }

  dismiss() {
    this.ref.close();
  }

}
